import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MessageInputService } from '@libs/collaboration';

/**
 * SupportCenterConversationComponent (which embeds lib-message-input) is not itself route-activated - it is
 * embedded unconditionally inside SupportCenterComponent, which the /support-center route(s) load. This guard
 * works regardless of which component ends up on the route.
 *
 * Only the support center composer's dictation is stopped here. The personal assistant composer has its own
 * MessageInputService and stops its dictation itself when the layout unmounts it on the support center route.
 */
export const supportCenterDictationGuard: CanDeactivateFn<unknown> = () => {
  inject(MessageInputService).stopDictationIfActive();

  return true;
};
